/*
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ESCAPE } from '@angular/cdk/keycodes';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PendoService } from '@fleetmatics/ui.insights';
import { FmMenuPanelComponent } from '@fleetmatics/ui.navbar';
import { isElementNull } from '../../../../utils';
import { ESearchEntityType, ISearchLightCategory, ISearchLightResult } from '../../model';

@Component({
  selector: 'fm-search-light-category-results-menu',
  templateUrl: './search-light-category-results-menu.component.html',
  styleUrls: ['./search-light-category-results-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'fmSearchLightCategoryResultsMenu'
})
export class FmSearchLightCategoryResultsMenuComponent {
  @Input()
  public category: ISearchLightCategory;

  public readonly ESearchEntityType = ESearchEntityType;

  @Output()
  public resultSelect: EventEmitter<ISearchLightResult> = new EventEmitter();

  @Output()
  public menuClose: EventEmitter<void> = new EventEmitter();

  @Output()
  public menuChange: EventEmitter<FmMenuPanelComponent> = new EventEmitter();

  @ViewChild(FmMenuPanelComponent, { static: false })
  public set menu(menu: FmMenuPanelComponent) {
    this._menu = menu;
    this.menuChange.emit(this._menu);
  }

  constructor(private readonly _pendoService: PendoService) {}

  public get menu(): FmMenuPanelComponent {
    return this._menu;
  }

  private _menu: FmMenuPanelComponent;

  public onMenuOptionKeydown(event: KeyboardEvent): void {
    if (event.keyCode === ESCAPE) {
      this.menuClose.emit();
    }
  }

  public open(focus: boolean = true): void {
    this._menu.open();
    if (focus) {
      this._menu.focusFirstItem();
    }
  }

  public close(): void {
    this._menu.close();
  }

  public shouldShowMenu(): boolean {
    return (
      this.category !== undefined &&
      this.category !== null &&
      this.category.items !== undefined &&
      this.category.items !== null &&
      this.category.items.length > 0
    );
  }

  public onMenuOptionSelected(result: ISearchLightResult): void {
    if (!isElementNull(result.lat) && !isElementNull(result.lng)) {
      this.resultSelect.emit(result);
      this._pendoService.trackEvent('livemap_search_converted', {
        search_text: result.text,
        entity_type_clicked: this.category.entityType || 'Unknown'
      });
    }
  }

  public onMenuOptionHovered(result: ISearchLightResult): void {
    if (!result.lat || !result.lng) {
      this._pendoService.trackEvent('livemap_search_disabled_hovered', {
        disabled_item: result.text,
        reason: result.type === ESearchEntityType.Driver && isElementNull(result.meta) ? 'DRIVER_NOT_ASSIGNED' : 'DISABLED_STATE',
        entity_type: this.category.entityType || 'Unknown'
      });
    }
  }
}
